import LookUpModel from "./LookUpModel";

export default class DocumentTypeModel extends LookUpModel {
    constructor(data: Partial<DocumentTypeModel>) {
        super(data);

        this.update(data);
    }
}
